import React from 'react'
import Layout from '../../components/Layout'
import FactsMaca from '../../components/Macademia/FactsMaca'
import IntroMaca from '../../components/Macademia/IntroMaca'
import TypesMaca from '../../components/Macademia/TypesMaca'
import Seo from '../../components/Seo'

export default function macademia({ location }) {
    return (
        <Layout location={location}>
            <Seo title="Zenith Pro | Macademia Nuts" />
            <IntroMaca />
            <FactsMaca />
            <TypesMaca />
        </Layout>
    )
}
